import { useCallback, useEffect, useRef } from "react";

function useDebouncedFunction(callback: (...params: any[]) => void, delay = 500) {
    const timeoutRef = useRef<NodeJS.Timeout>();
    const clearT = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    
    useEffect(() => {
        return () => {
            clearT();
        };
    }, []);
    
    const debouncedFunction = useCallback((...params: any[]) => {
        clearT();
        
        timeoutRef.current = setTimeout(() => {
            callback(...params);
        }, delay)
    }, [callback, delay]);

    return debouncedFunction;
}

export default useDebouncedFunction;